import React from 'react';
import { useSelector } from 'react-redux';
import ButtonWithClose from '@/components/ButtonWithClose';
import ColumnsSelector from '@/components/ColumnsSelector';
import {
  ALL,
  COUNT,
  EARLIEST,
  IncludeType,
  LATEST,
} from '@/util/enums/EnumIncludeType';
import ViewRef from '@/util/ViewRef';
import { getDatasourceTablesWithCreatedAt } from '@/store-selectors';
import { changeMode, TABLES } from '@/features/joinModal/joinModalSlice';
import { useAppDispatch } from '@/store/hooks';
import { checkForCreatedAt } from '@/components/modals/ModalJoin/helpers';
import { JoinModeProps } from '../../types';

export const JoinSuggested: React.FC<JoinModeProps> = ({
  children,
  state,
  columns,
  userInteraction,
  renderer,
}) => {
  const tablesWithCreatedAt = useSelector(getDatasourceTablesWithCreatedAt);
  const dispatch = useAppDispatch();

  const values = columns.flatMap((c) => c.fks());

  const showBringIn =
    state.joinType !== 'cross' &&
    state.selected &&
    !(state.selected.foreignColumn().tov() instanceof ViewRef) &&
    (!state.selected.foreignColumn().tov().isMasterTable ||
      !state.selected.foreignColumn().tov().isMasterTable());

  const hasCreatedAt = state.selected
    ? checkForCreatedAt(state.selected, tablesWithCreatedAt)
    : true;

  const changeIncludeType = (includeType: IncludeType) => {
    userInteraction({ section: 'includeType', newValue: includeType })(
      undefined,
    );
  };

  const handleSwitchToJoinTables = (e: React.MouseEvent) => {
    userInteraction({ section: 'custom' })(e);
    dispatch(changeMode(TABLES));
  };

  return (
    <div>
      <div>
        {values.length === 0 && (
          <div className="faint">
            No joins found (ask your Trevor.io admin to "Configure joins" for
            this table).
          </div>
        )}

        {state.selected && (
          <div className="margin-bottom-20">
            <ButtonWithClose
              userInteraction={userInteraction}
              data={{ section: 'deselect' }}
              text={renderer.renderValue(state.selected)}
              tooltip={renderer.renderValue(state.selected, true)}
            />
          </div>
        )}

        {!state.selected && values.length > 0 && (
          <ColumnsSelector
            values={values}
            selectedValue={state.selected}
            renderer={renderer}
          />
        )}

        {showBringIn && (
          <div className="margin-bottom-20">
            <p>
              <b>Bring in</b>
            </p>
            <select
              value={state.includeType as IncludeType}
              className="form-control include-type"
              onChange={(e) =>
                changeIncludeType(e.currentTarget.value as IncludeType)
              }
            >
              <option value={ALL}>All matching rows (default)</option>
              {hasCreatedAt && (
                <>
                  <option value={LATEST}>Only latest matching row</option>
                  <option value={EARLIEST}>Only earliest matching row</option>
                </>
              )}
              <option value={COUNT}>Row counts</option>
            </select>
          </div>
        )}
      </div>
      {children}
      {!state.selected && <hr />}
      {!state.selected && !(state.joinType === 'cross') && (
        <div className="clear-both padding-5">
          <a href="#" onClick={handleSwitchToJoinTables}>
            <b>Or, launch custom join wizard</b> (to join a table or saved
            query)
          </a>
        </div>
      )}
    </div>
  );
};
